import { usePagination } from "../../../../hooks/usePagination"
import ResultHandler from "../../../../components/ResultHandler"
import PaginationHandler from "../../../../components/PaginationHandler"
import TableHeaderHandler from "../../../../components/TableHeaderHandler"
import EmptyData from "../../../../components/EmptyData"
import { Table, Thead, Tbody, Td, Tr, Th } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { useParams, useLocation } from "react-router-dom"
import TableFilter from "../../../../components/TableFilter"
import moment from "moment"
import { Button } from "reactstrap"
import { useResponse } from "../../../../hooks/useResponse"
import { cancelReservation, deAssignReservation } from "../../../../api/reservation"
import { useState } from "react"
import DeAssignReservationModal from "../../../../components/reservation-modal/DeAssignReservationModal"
import DeleteModal from "../../../../components/Common/DeleteModal"
import { getHousingRenters } from "../../../../api/housing"


export default function HousingRentersTable() {
  const {housingId} = useParams()

  const {
    response,
    loading,
    error,
    setPage,
    page,
    setPerPage,
    totalPages,
    setPayload,
    setMeta
  } = usePagination(getHousingRenters, {housingId})

  
  // Filter
  const filterTypes = [
    {key: "start", type: "date"},
    {key: "end", type: "date"},
  ]


  // De Assign
  const [showDeAssignModal, setShowDeAssignModal] = useState(false)
  const [deAssignedEntity, setDeAssignedEntity] = useState(null)

  const { setData: setDeAssignedData, error: deAssignError } = useResponse(deAssignReservation, () => {
    setShowDeAssignModal(false)
    setDeAssignedEntity(null)
    setPayload({ref: true, housingId})
  })

  function onDeAssignConfirm(date) {
    setDeAssignedData({ type: "edit", id: deAssignedEntity, data: { date } })
  }

  function onDeAssignCancel() {
    setShowDeAssignModal(false)
  }


  // Cancel
  const [showCancelModal, setShowCancelModal] = useState(false)
  const [canceledEntity, setCanceledEntity] = useState(null)

  const { setData: setDeCanceledData, error: cancelError } = useResponse(cancelReservation, () => {
    setShowCancelModal(false)
    setCanceledEntity(null)
    setPayload({ref: true, housingId})
  })

  function onCancelConfirm() {
    setDeCanceledData({ type: "delete", data: canceledEntity })
  }

  function onCancelCancel() {
    setShowCancelModal(false)
  }


  return (
    <>
      <TableHeaderHandler
        setPage={setPage}
        setPerPage={setPerPage}
      >
      </TableHeaderHandler>
      
      <TableFilter
        filterTypes={filterTypes}
        onFilter={(filters) => setMeta({ page: 1, payload: {housingId, ...filters} })}
      />

      {response.data && !loading && response.data.reservations.length > 0 && <div className="mb-4 d-flex gap-2" style={{fontSize: '15px'}}>
        <b>Housing: </b>
        <span>
          {response.data.reservations[0]?.room?.housing?.street_name}{" "}
          {response.data.reservations[0]?.room?.housing?.number}{" "}
          {response.data.reservations[0]?.room?.housing?.city}
        </span>
      </div>}

      <div className="table-rep-plugin">
        <div className="table-responsive">
          <Table className="table table-striped table-bordered">
            <Thead className="table-light table-nowrap">
              <Tr>
                <Th>Name</Th>
                <Th>Start</Th>
                <Th>End</Th>
                <Th>Room Number</Th>
                <Th>Action</Th>
              </Tr>
            </Thead>

            {response.data && !loading && (
              <Tbody>
                {response.data.reservations.map(row => {
                  return (
                    <Tr key={row.id}>
                      <Td>
                          {row.employee_id && <span>{row.employee?.name}</span>}
                          {row.admin_id && <span>{row.admin?.name}</span>}
                          {row.contract_id && <span>{row.contract?.company?.name}</span>}
                      </Td>
                      <Td>{row.startAt && moment(row.startAt).format("DD MMM YYYY")}</Td>
                      <Td>{row.endAt && moment(row.endAt).format("DD MMM YYYY")}</Td>
                      <Td>{row.room.room_number}</Td>
                      <Td>
                          {(row.endAt === null || (row.startAt < new Date().toISOString() && row.endAt >= new Date().toISOString())) && ( 
                            <Button
                            color="danger"
                            className="fw-bold text-nowrap"
                            onClick={() => {
                              setShowDeAssignModal(true);
                              setDeAssignedEntity(row.id);
                            }}
                            >
                              De Assign
                            </Button>
                          )}

                          {row.startAt > new Date().toISOString() && row.endAt > new Date().toISOString() && (
                            <Button
                              color="danger"
                              style={{ marginLeft: "5px" }}
                              className="fw-bold text-nowrap"
                              onClick={() => {
                                setShowCancelModal(true);
                                setCanceledEntity(row.id);
                              }}
                            >
                              Cancel
                            </Button>
                          )}
                      </Td>
                    </Tr>
                  )
                })}
              </Tbody>
            )}
          </Table>

          {!loading && <EmptyData empty={response.data && response.data.reservations.length === 0} msg="No Renters Found." /> }

          {response.data && !loading && <PaginationHandler page={page} setPage={setPage} totalPages={totalPages} /> }

          <ResultHandler error={error} loading={loading} />

          {/* De Assign */}
          <DeAssignReservationModal
            show={showDeAssignModal}
            onConfirm={onDeAssignConfirm}
            onCloseClick={onDeAssignCancel}
            error={deAssignError}
          />

          {/* Cancel */}
          <DeleteModal
            show={showCancelModal}
            onDeleteClick={onCancelConfirm}
            onCloseClick={onCancelCancel}
            error={cancelError}
          />
        </div>
      </div>
    </>
  )
}
